module.exports = __webpack_public_path__ + "img/block_big.023060a8.png";